<!-- 客户管理 -- 往届生续费 -- 列表 -->
<template>
	<div>
		<list-template
				:current-page="page"
				:is-check-input-box="false"
				:isDownload="true"
				:loading="loading"
				:search-config="searchConfig"
				:table-config="tableConfig"
				:table-data="tableData"
				:total="total"
				@onChangePage="handleCurrentChange"
				@onExportData="onDownload(0)"
				@onExportAll="onDownload(1)"
				@onHandle="handleEdit"
				@onSearch="onSearch"
        @onReset="onReset"
		></list-template>
	</div>
</template>

<script>
import {mapState} from "vuex";
import ListTemplate from "@/components/pages/List.vue"
import { fileDownload, getActualSchool, getAllGrade, get_recruit_dict } from '@/api'
import { setConfigOption } from '@/utils'

export default {
	_config: {"route": {"path": "list", "meta": {"title": "列表", "keepAlive": true}}},
	components: {ListTemplate},
	data() {
		return {
			loading: true,
			search: {},
      optionData: [],
			searchConfig: [
				{ prop: "student_name", placeholder: "搜索学生姓名" },
				{ prop: 'approve_status', tag: "select", placeholder: '筛选审批状态', options: [] },
				{ prop: 'school_id', tag: "select", placeholder: '筛选报名校区', options: [] },
				{ prop: 'grade_id', tag: "select", placeholder: '筛选入学年级', options: [] },
				{ prop: 'student_type', tag: "select", placeholder: '筛选学生类型', options: [], change: (val, search) => {
          if (search.business_line) search.business_line = ''
          let list = []
          if (val === 2) {
            list = this.optionData.filter(item => [2,5].includes(item.value))
          } else {
            list = this.optionData.filter(item => [1,3,4].includes(item.value))
          }
          setConfigOption({ list: this.searchConfig , data: list, key: 'business_line' })
        }},
				{ prop: 'business_line', tag: "select", placeholder: '筛选所属业务线', options: [] }
			],
			tableData: [],
			//总条数
			total: 0,
			pageCount: 0,
			tableConfig: [
				{
					prop: "status", label: "审批状态",
					render(row) {
						return `<div style="color: ${row['approve_status'] === '待审批' ? '#F6AD3C' : row['approve_status'] === '已通过' ? '#23C343' : '#F53F3F'}">${row['approve_status']}</div>`
					}
				},
				{prop: "student_name", label: "学生姓名"},
				{prop: "student_type", label: "学生类型"},
				{prop: "business_line", label: "所属业务线"},
				{prop: "school_name", label: "报名校区"},
				{prop: "grade_name", label: "入学年级"},
				{prop: "payment_amount", label: "应缴金额"},
				{prop: "paid_amount", label: "已缴金额"},
				{prop: "creator", label: "录入人"},
				{prop: "created_at", label: "录入时间"},
				{
					prop: "handle",
					label: "操作",
					width: "120rem",
					handle: true,
				},
			],
		}
	},
	created() {
		this.$store.commit("setPage", 1);
		this.getData()
    this.getConfig()
	},
	activated() {
		this.getData()
	},
	computed: {
		...mapState(["page"])
	},
	methods: {
    getConfig() {
      getActualSchool().then(res => {
        setConfigOption({ list: this.searchConfig , data: res, key: 'school_id' })
      })
      getAllGrade().then(res => {
        setConfigOption({ list: this.searchConfig, data: res, key: 'grade_id' })
      })
      get_recruit_dict().then(res => {
        setConfigOption({ list: this.searchConfig , data: res.student_type, key: 'student_type' })
        setConfigOption({ list: this.searchConfig , data: res.business_line, key: 'business_line' })
        setConfigOption({ list: this.searchConfig , data: res.approve_status, key: 'approve_status' })
        this.optionData = res.business_line
      })
    },
		getData() {
			this.loading = true
			let params = {...this.search, page: this.page}
			this.tableData = [];
			this.$_register('api/recruit-v2/approve-fresh/list', {params}).then(res => {
				let data = res.data.data
				this.tableData = data.list
				this.total = data.page.total
			}).finally(() => {
				this.loading = false
			})
		},
    onReset() {
      const list = JSON.parse(JSON.stringify(this.optionData))
      setConfigOption({ list: this.searchConfig , data: list, key: 'business_line' })
    },
		onSearch(val) {
			this.$store.commit('setPage', 1);
			this.search = val;
			this.getData(val)
		},

		handleEdit(row, text) {
      const type = text.type
      if (type === 'approve') {
        this.$router.push('./approve?id=' + row.id)
      } else if (type === 'view') {
        this.$router.push('./detail?id=' + row.id)
      } else if (type === 'edit') {
        this.$router.push('./edit?id=' + row.id)
      }
		},

		handleCurrentChange(val) {
			this.$store.commit("setPage", val);
			this.getData()
		},

		onDownload(type) {
      const arr = [
        { api: 'export-v2', title: '数据' },
        { api: 'export-detail', title: '缴费明细' }
      ]
      const obj = arr[type]
			let params = {...this.search, page: this.page}
      fileDownload(`/zhaosheng/api/recruit-v2/approve-fresh/${obj.api}`, params, { name: `补录收费审批${obj.title}` })
		}

	},
}
</script>

<style lang="scss" scoped>

.role-list {
	padding-top: 24rem;
}

.button {
	border-radius: 4rem;
	box-sizing: border-box;
	height: 34rem;
	margin-bottom: 30rem;
	margin-left: 34rem;
	opacity: 1;
	width: 90rem;
}

.table {
	margin-left: 32rem;
}


::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
	box-sizing: border-box;
	color: #333333;
	font-size: 14rem;
	font-weight: normal;
	height: 48rem;
	text-align: left;
}

.header {
	color: #333333;
	font-size: 16rem;
	font-weight: bold;
	left: 300rem;
	letter-spacing: 3.5rem;
	line-height: 24rem;
	position: fixed;
	top: 120rem;
}

.el-button--text {
	color: #3491fa;
	font-size: 14rem;
	font-weight: normal;
	margin-right: 40rem;
}
</style>
